import { render, staticRenderFns } from "./ActionBtns.vue?vue&type=template&id=31580b15&scoped=true&"
import script from "./ActionBtns.vue?vue&type=script&lang=js&"
export * from "./ActionBtns.vue?vue&type=script&lang=js&"
import style0 from "./ActionBtns.vue?vue&type=style&index=0&id=31580b15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31580b15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
